/*
* 
*/

import logger from '../loggers/logger';

// facets
export const PARAM_MISSION: string='mis';
export const PARAM_INSTRUMENT: string='ins';
export const PARAM_CALENDARTYPE: string='cat';
export const PARAM_LEVEL: string='lev';
export const PARAM_PRODUCTTYPE: string='prt';
export const PARAM_DOCUMENTTYPE: string='dot';

// sort by
export const PARAM_SORTBY: string='sby';
export const PARAM_SORTBYDIRECTION: string='sbd';

// show by (pagination)
export const PARAM_SHOW: string='sho';
// view by (date range)
export const PARAM_VIEWBY: string='vby';
export const PARAM_DATESTART: string='dts';
// search field
export const PARAM_SEARCHBAR: string='sbt';
// view list/cal switch
export const PARAM_VIEWTYPE: string='slc';
// current page in list view
export const PARAM_PAGE: string='page';
// modal parameters
export const PARAM_MODAL: string='modal';
export const PARAM_MODAL_DATE: string='mdt';
export const PARAM_MODAL_MISSION: string='mmis';
// date interval filter parameters
export const PARAM_DATE_FROM: string='dfrom';
export const PARAM_DATE_TO: string='dto';


//const KNOWN_PARAMS_NAMES: Array<string>=[
//    'mis','ins','cat', 'lev','prt', 'dot',
//    ]

//interface Dictionary<T> {
//    [Key: string]: T;
//}








//
// returns array compatible with store selected facet
//
export function parseQueryStringForFacets(query: URLSearchParams): Array<string>{
    var urlFacetsConstraints: Array<string> = [];
    
    // Support multiple values for each facet type
    const facetMappings = [
        { param: PARAM_MISSION, field: 'mission_ss' },
        { param: PARAM_INSTRUMENT, field: 'instrument_ss' },
        { param: PARAM_CALENDARTYPE, field: 'calendartype_ss' },
        { param: PARAM_LEVEL, field: 'level_ss' },
        { param: PARAM_PRODUCTTYPE, field: 'producttype_ss' },
        { param: PARAM_DOCUMENTTYPE, field: 'documenttype_ss' }
    ];

    facetMappings.forEach(({ param, field }) => {
        const values = query.getAll(param);
        values.forEach(value => {
            if (value && value.trim()) {
                //logger.info(`@@@@@@ parseQueryStringForFacets; ${param}=${value}`);
                urlFacetsConstraints.push(`${value.trim()}@${field}`);
            }
        });
    });

   return urlFacetsConstraints;
}

export function parseModalParams(query: URLSearchParams) {
    return {
        modalOpen: query.get(PARAM_MODAL) === 'open',
        modalDate: query.get(PARAM_MODAL_DATE) || '',
        modalMission: query.get(PARAM_MODAL_MISSION) || ''
    };
}